import { render } from "./ApiUsages.vue?vue&type=template&id=ffd413c4&ts=true"
import script from "./ApiUsages.vue?vue&type=script&lang=ts"
export * from "./ApiUsages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__